import styled, { css } from 'styled-components';
import { ColProps, RowProps } from './GridTypes';

export const Col = styled.div<ColProps>`
  ${({ xs }) =>
    xs &&
    css`
      flex: ${(100 / 12) * xs}% 0 0;
    `}
`;

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  justify-content: ${({ justify = 'start' }) => justify};
  align-items: ${({ align = 'stretch' }) => align};
  gap: ${({ theme, spacing = 1 }) => theme.spacing[`km${spacing}`]};
  height: 100%;

  ${({ marginTop, theme }) =>
    marginTop &&
    css`
      margin-top: ${theme.spacing[marginTop]};
    `}
`;
